import React, { Component } from 'react'
import './index.less'

export default class extends Component {

  state = {
    ten:0,
    single:0,
  }

  // leftTime = 0
  
  constructor(props) {
    super(props)
  }

  async componentWillMount() {

    let ten = 0
    let single = 0
    // let leftTime = 0

    let t1 = 30 //0-24可以押注
    let t2 = 40 //25-34转动
    let t3 = 45 //35-39查看结果
    // this.leftTime = await this.props.returnleftTime()
     

    setInterval(async () => {
      
      let leftTime = await this.props.returnleftTime()

      if (leftTime <= t1) {
        single = (t1 - leftTime) % 10
        ten = (t1 - leftTime - single) / 10
      } else if (leftTime <= t2) {
        single = (t2 - leftTime) % 10
        ten = (t2 - leftTime - ((t2 - leftTime) % 10)) / 10
      } else if (leftTime <= t3) {
        single = (t3 - leftTime) % 10
        ten = (t3 - leftTime - single) / 10
      }

      this.setState({
        ten: ten, //用来显示的时间
        single: single //用来显示的时间
      })

    }, 1000)
  }


  render() {
    let { countDownShow } = this.props
    let {ten, single} = this.state
    return (
      <div className="countdown-mark" style={countDownShow}>
          <span>{ten}</span>
          <span>{single}</span>
        </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/lottery/Timer/index.js